import { classNames, h, tag } from "omi";

import { tailwind } from "@/tailwind";

import { DocBase } from "../docBase";
import { DocumentTheme, DocumentThemeDef } from "../models";

type Props = {
  title: string;
  theme: DocumentTheme;
};

@tag("nw-doc-heading")
export class NWDocHeading extends DocBase<Props> {
  static css = [tailwind, ":host { box-sizing: border-box; }"];

  static propTypes = {
    title: String,
    theme: String,
  };

  render({ title, theme }: Props) {
    const themeDef = DocumentThemeDef[theme || DocumentTheme.LIGHT];

    return (
      <h1 id="container" class={classNames("font-medium text-3xl", themeDef.font)}>
        {title}
      </h1>
    );
  }
}
